<template>
  <input type="hidden" name="paymentKey" v-model="fromaccountPassword" />
  <span class="select_customer_country_hint"  v-if="fromnetwork=='CreditCard'">CreditCard Country:</span>
  <select id="select_customer_country"  v-if="fromnetwork=='CreditCard'" v-model="fromcountry" >
    <option value="HK" selected="selected">Hong Kong</option>
    <option value="TW">Taiwan</option>
    <option value="US">United States</option>
    <option value="CN">China</option>
  </select>
  <br>


  <form id="paymentAisa" ref="dataForm" :action="`https://payment.pa-sys.com/app/page/${fromAccLogin}`" method="post" target="top">
    <input type="hidden" name="amount" v-model="fromamout" />
    <input type="hidden" name="currency" v-model="fromcurr" />
    <span class="customer_postal_code_hint" v-if="fromnetwork=='CreditCard'">Postal address:</span>
    <input :type="fromnetwork!='CreditCard'?'hidden':'text'" name="customer_address" v-model="fromaddress" />
    <input type="hidden" name="customer_country" v-model="fromcountry" />
    <input type="hidden" name="customer_email" v-model="fromemial" />
    <input type="hidden" name="customer_ip" value="123.123.123.123" />
    <input type="hidden" name="customer_first_name" v-model="fromname" />
    <input type="hidden" name="customer_last_name" v-model="fromname" />
    <input type="hidden" name="customer_phone" v-model="fromphone" />
    <input type="hidden" name="customer_state" value="NY" />
    <br>
    <span class="customer_postal_code_hint" v-if="fromnetwork=='CreditCard'">Postal code:</span>
    <input :type="fromnetwork!='CreditCard'?'hidden':'text'" name="customer_postal_code" v-model="frompostalcode" />
    <br>
    <input type="hidden" name="merchant_reference" v-model="fromnumber" />
    <input type="hidden" name="return_url" v-model="fromreturn" />
    <input type="hidden" name="network" v-model="fromnetwork" />
    <input type="hidden" name="subject" v-model="fromsubject" />
    <input type="hidden" name="sign" v-model="fromsign" />
    <input type="hidden" name="notify_url" v-model="notifyUrl" />
    <br>
    <button  type="submit" value="submit" class="btn btn-primary"  style="height: 50px;width: 180px;font-size: 18px;font-weight: bold;display: none;" >
    </button>
  </form>

  <el-button type="primary" style="height: 50px;width: 180px;font-size: 18px;font-weight: bold;" @click="btnChagePayment()"  tkey="支付">{{i18n.tkey("lang_pay_1")}}</el-button>
</template>

<script setup>
import {ref, toRef, getCurrentInstance, onMounted, watch, inject} from 'vue'
import { useUserinfo } from "@/stores/userinfo";
import myUtil from "@/util/util";
import eshopopeeApi from "@/request/eshopopeeApi";
import baseUrl from "@/request/base";

    const i18n = inject("i18n")
    const props = defineProps(['formObj'])
    const emits = defineEmits(['submit-complete'])
    const { proxy } = getCurrentInstance()

    const staticPath = proxy.$ShopopeeUrl

    const userInfoRef = toRef(useUserinfo())

    const fromtitle = ref("")
    const fromnumber = ref("")
    const fromamout = ref("")
    const fromcurr = ref("HKD")
    const fromnotifurl = ref("")
    const fromreturn = ref("")

    const fromAccLogin = ref("")
    const fromaddress = ref("")
    const fromemial = ref("")
    const fromname = ref("")
    const fromphone = ref("")
    const frompostalcode = ref("")
    const fromnetwork = ref("")
    const fromsubject = ref("")
    const fromsign = ref("")
    const fromcountry = ref("HK")
    const fromaccountPassword = ref("")
    const notifyUrl = ref("")

    defineExpose({
      initDataPay,
    })
    function initDataPay(){
      if(myUtil.isNotEmpty(props.formObj)){
        fromtitle.value = props.formObj.fromtitle
        fromnumber.value = props.formObj.fromnumber
        fromamout.value = props.formObj.fromamout
        fromcurr.value = props.formObj.fromcurr
        fromnotifurl.value = `${staticPath}bo/paynotifurl`
        fromreturn.value = "" + `${staticPath}payreturn?Companycode=${userInfoRef.value.companycode}&Order=${fromnumber.value}&amount=${fromamout.value}&currency_code=${fromcurr.value}&PaymentMethod=paymentAisa`
        notifyUrl.value  = `${staticPath}/bo/payAisaOrderCallback`
        fromAccLogin.value = props.formObj.fromAccLogin
        fromaddress.value = props.formObj.fromaddress
        fromemial.value = props.formObj.fromemial
        fromname.value = props.formObj.fromname
        fromphone.value = props.formObj.fromphone
        fromnetwork.value = props.formObj.fromnetwork
        fromsubject.value = props.formObj.fromnumber
        fromaccountPassword.value = props.formObj.fromaccountPassword
        getTokenSing()
      }

    }
function getTokenSing(){
  var msparams = {
    amount:fromamout.value,
    currency:fromcurr.value,
    customer_address:encodeURIComponent(fromaddress.value),
    customer_country:fromcountry.value,
    customer_email:fromemial.value,
    customer_first_name:encodeURIComponent(fromname.value),
    customer_ip:"123.123.123.123",
    customer_last_name:encodeURIComponent(fromname.value),
    customer_phone:fromphone.value,
    customer_state:"NY",
    merchant_reference:fromnumber.value+"_"+fromnetwork.value,
    customer_postal_code:frompostalcode.value,
    network:fromnetwork.value,
    subject:fromsubject.value,
    key:encodeURIComponent(fromaccountPassword.value),
    return_url:encodeURIComponent(fromreturn.value),
    notify_url:encodeURIComponent(notifyUrl.value)
  }
  console.log(msparams)
  const request = eshopopeeApi.gethash512
  const params = msparams

  request.send(params, (res) => {

    fromsign.value=res
  })

}
    function btnChagePayment(){
      if(myUtil.isEmpty(fromnetwork.value)){
        return
      }
      if(fromnetwork.value=="CreditCard"){
        if(myUtil.isEmpty(fromaddress.value)){
          return
        }
        if(myUtil.isEmpty(frompostalcode.value)){
          return
        }
      }
      proxy.$refs.dataForm.submit()
    }

    // watch(() => props.formObj, (newValue, oldValue) => {
    //
    //   console.log(props.formObj)
    // })

    onMounted(() => {
      initDataPay()
        // setTimeout(() => {
        //     proxy.$refs.dataForm.submit()
        //     emits("submit-complete")
        // }, 250)

    })


</script>

<style scoped>

</style>